import axios from "axios";
import {
  IP
} from "../index.js";
/* 预约订单 */
export async function selectArchives(data) {
  var resp = await axios.post(`${IP}/admin/archives/select`, data);
  return resp.data;
}

export async function addArchives(data) {
  var resp = await axios.post(`${IP}/admin/archives/add`, {
    ...data
  });
  return resp.data;
}

export async function updateArchives(data) {
  var resp = await axios.post(`${IP}/admin/archives/update`, {
    ...data
  });
  return resp.data;
}

export async function deleteArchives(data) {
  var resp = await axios.post(`${IP}/admin/archives/delete`, data);
  return resp.data;
}

